import { FC } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

interface BackupUsersAutoCompleteProps {
    disabled: boolean;
    users: string[];
    selectUser: (value: string) => void;
}

const BackupUsersAutoComplete: FC<BackupUsersAutoCompleteProps> = ({ disabled, users, selectUser }) => {
    return (
        <Autocomplete
            sx={{ width: 245 }}
            size='small'
            disabled={disabled}
            options={users}
            autoHighlight
            disableClearable
            onChange={(_event, value) => selectUser(value!)}
            getOptionLabel={(option) => option}
            renderOption={(props, option) => {
                return (
                    <li {...props}>
                        {option}
                    </li>
                );
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                />
            )}
        />
    );
}

export default BackupUsersAutoComplete;